const BROWSER_ID_KEY = 'browser_id';

const fallbackUuid = () => {
  // Fallback RFC4122 v4-ish cuando randomUUID no esta disponible.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : 8 + (r % 4);
    return v.toString(16);
  });
};

const safeCreateBrowserId = () => {
  try {
    if (globalThis.crypto && typeof globalThis.crypto.randomUUID === 'function') {
      return globalThis.crypto.randomUUID();
    }
  } catch (error) {
    // Continúa con fallback si falla acceso a crypto.
  }
  return fallbackUuid();
};

/**
 * Obtiene el identificador persistente del navegador desde localStorage.
 * Si no existe, genera uno nuevo con crypto.randomUUID() y lo persiste.
 * @returns {string}
 */
export const getBrowserId = () => {
  try {
    const storedBrowserId = localStorage.getItem(BROWSER_ID_KEY);
    if (storedBrowserId) {
      return storedBrowserId;
    }

    const browserId = safeCreateBrowserId();
    localStorage.setItem(BROWSER_ID_KEY, browserId);
    return browserId;
  } catch (error) {
    // Si localStorage no esta disponible (modo privado/politicas), igualmente retorna un id.
    return safeCreateBrowserId();
  }
};

export default getBrowserId;
